export default "__VITE_ASSET__03953dd3__"